import { useDispatch, useSelector } from "react-redux"

import { allNgPatientStatusesOptions, isTestCaseForLien, ngPatientStatusesOptionsFiltered, practicePatientStatusesOptions, treatmentStatusesOptions } from "../../../../lib/systemData"
import CopyText from "../../../fragments/CopyText"
import { checkIfLopIsRequired, formatCurrency, returnPractice } from "../../../../lib/script"
import CustomSelect from "../../../common/interactive/CustomSelect"
import { caseActions } from "../../../../store/case"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import PracticesUploadItem from "../procodocs/practicesupload/PracticesUploadItem"
import RecordsUploadContainer from "../recordsUpload/RecordsUploadContainer"
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency"
import DateDisplayWithModal from "../../../common/DateDisplayWithModal"
import DisplayBoxRight from "../../../fragments/DisplayBoxRight"
import TransferClinicWrapper from "./TransferClinicWrapper"
import { isManagingAttorney } from "../../../../lib/primaryItemScripts"
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions"
import { practicesFunctions } from "../../../../lib/practices"

const PracticeItem = ({item, managingAttorney, viewAmounts}) => {
    const dispatch = useDispatch()
    const practiceSystem = returnPractice(item?.practice_id)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    let uploadPermission = useUserTabEditPermissionDisabled('procodocs_documents_upload')
    let updatePermission = useUserTabEditPermissionDisabled('procodocs_documents_update')

    const updateHandler = async (data) => {
           
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }

        dispatch(caseActions.modifyActiveCase({
            folder: data.identifier.folder,
            item: {
                itemId: item?.id,
                field: data.identifier.field,
                value: data.data.value,
            },
        }))

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
        }   
    }


    let injectStatus = null

    if (!item?.status_id && item?.nextgen_patient_status) {
        // injectStatus = {
        //     label: item?.nextgen_patient_status,
        //     value: item?.nextgen_patient_status,
        //     manual_selection: true
        // }

        injectStatus = allNgPatientStatusesOptions()?.find(option => option.value == item?.nextgen_patient_status)
    }

    // if (!item?.status_id) {
    //     injectStatus = {
    //         label: 'Next Gen',
    //         value: 'next_gen',
    //         manual_selection: true
    //     }
    // }

    return <>
        {practiceSystem && <tr >
            <td>
                {/* {practiceSystem.name} */}
                {practiceSystem?.short_name ? practiceSystem?.short_name : practiceSystem?.name}
            </td>
            <td>
                {item?.chart_number && <CopyText text={item?.chart_number} />}
            </td>
            {viewAmounts && <td>
                {isTestCaseForLien(activeCase) ? <>
                    <InputBoxCurrency currentValue={item?.total_charges} action={updateHandler} name={'total_charges'}  identifier={{type: 'case_practice', field: 'total_charges', type_id: item?.id, folder: 'practices'}} textRight={true}/>
                </>
                :
                <><DisplayBoxRight>${formatCurrency(item?.total_charges)}</DisplayBoxRight></>
                }
            </td>}
            {viewAmounts && <td>
                {isTestCaseForLien(activeCase) ? <>
                    <InputBoxCurrency currentValue={item?.balance} action={updateHandler} name={'amount'}  identifier={{type: 'case_practice', field: 'balance', type_id: item?.id, folder: 'practices'}} textRight={true}/>
                </>
                :
                <><DisplayBoxRight>${formatCurrency(item?.balance)}</DisplayBoxRight></>
                }
                
            </td>}
            {practicesFunctions.getPracticeType(item?.practice_id) == '1' ? <>
                <td style={{width: 180, padding: 0}}>
                    {/* <CustomSelect action={updateHandler} optionsData={treatmentStatusesOptions(false, injectStatus)} preSelectedValue={item?.status_id || injectStatus?.value} sameSizeAsContainer={true} minWidth={120} identifier={{type: 'case_practice', field: 'status_id', type_id: item?.id, folder: 'practices'}} fixedDrawer={true}/> */}
                    <CustomSelect action={updateHandler} optionsData={practicePatientStatusesOptions(false, injectStatus)} preSelectedValue={item?.status_id || injectStatus?.value} sameSizeAsContainer={true} minWidth={120} identifier={{type: 'case_practice', field: 'status_id', type_id: item?.id, folder: 'practices'}} fixedDrawer={true}/>
                </td>
                {isTestCaseForLien(activeCase) && <td>
                    <CustomSelect action={updateHandler} optionsData={ngPatientStatusesOptionsFiltered(item?.practice_id)} preSelectedValue={item?.next_gen_patient_status_id} sameSizeAsContainer={true} minWidth={120} identifier={{type: 'case_practice', field: 'next_gen_patient_status_id', type_id: item?.id, folder: 'practices'}} fixedDrawer={true}/>
                </td>}
                <td>-</td>
                <td className="table-cell-no-padding">
                    {item?.location_id ? <TransferClinicWrapper item={item}>
                        {practiceSystem.locations.find(loc => loc.id == item?.location_id)?.code}
                        {/* display_name */}
                    </TransferClinicWrapper> : <></>}               
                </td>
            </>
            :
            <>
                <td colSpan={isTestCaseForLien(activeCase) ? 4 : 3}></td>
            </>}
            {isManagingAttorney(activeCase) && <>
                {practicesFunctions.isPracticeRequiresHIPAA(item?.practice_id) ? <td>
                    <PracticesUploadItem practiceId={item?.practice_id} usedFor={'HIPAA'} uploadDisabled={true} caseAttorneyId={managingAttorney?.id} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission}/>
                </td> : <td></td>}
            </>}
            {checkIfLopIsRequired(managingAttorney, activeCase) && 
            <>
                {practicesFunctions.isPracticeRequiresLOP(item?.practice_id) ? <td>
                    <PracticesUploadItem practiceId={item?.practice_id} usedFor={'LOP'} uploadDisabled={true} caseAttorneyId={managingAttorney?.id} activeCase={activeCase} uploadPermission={uploadPermission} updatePermission={updatePermission}/>             
                </td> : <td></td>}
            </>}
            
            
            <td>
                <RecordsUploadContainer practiceitem={item} managingAttyId={managingAttorney?.id} userToken={userToken} activeCase={activeCase} docType={managingAttorney?.id ? 'procodocs' : 'document'}/>                
            </td>
            <td>
                <DisplayBoxRight>
                    <DateDisplayWithModal date={item?.initial_treatment}/>
                </DisplayBoxRight>
            </td>
        </tr>}
    </>
}

export default PracticeItem